'use strict';

var React = require('react');

var SvgCameraIcon = function SvgCameraIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 7.25a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5Zm-1.75 3.25a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.584 4a2.75 2.75 0 0 0-2.435 1.472l-.346.658a.691.691 0 0 1-.612.37c-1.21 0-2.191.981-2.191 2.191v4.559a2.75 2.75 0 0 0 2.75 2.75h8.5a2.75 2.75 0 0 0 2.75-2.75v-4.559c0-1.21-.981-2.191-2.191-2.191a.691.691 0 0 1-.612-.37l-.346-.658a2.75 2.75 0 0 0-2.435-1.472h-2.832Zm-1.107 2.169a1.25 1.25 0 0 1 1.107-.669h2.832c.465 0 .89.258 1.107.669l.345.658a2.191 2.191 0 0 0 1.94 1.173c.383 0 .692.31.692.691v4.559c0 .69-.56 1.25-1.25 1.25h-8.5c-.69 0-1.25-.56-1.25-1.25v-4.559c0-.381.31-.691.691-.691a2.19 2.19 0 0 0 1.94-1.173l.346-.658Z"
  }));
};
SvgCameraIcon.displayName = "CameraIcon";

exports.SvgCameraIcon = SvgCameraIcon;
